import { analyticsVersion } from './constants';
import { notifyEvent } from './eventListeners.state';
import {
  getGlobalAttributesResolver,
  getGlobalErrorHandler,
  getGlobalsSnapshot,
} from './global-state';
import { AnalyticsEvent, NormalizedEventAttributes } from './types';
import {
  attrNameToDisplayName,
  onlyValidAttributes,
  serializeObject,
} from './utils';

const defaultKeySerializer = ({ key }: { key: string; value: unknown }) =>
  attrNameToDisplayName(key);
const defaultValueSerializer = ({ value }: { key: string; value: unknown }) => {
  if (typeof value === 'string' || typeof value === 'number') {
    return value;
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  return undefined;
};

export const raiseEvent = (event: AnalyticsEvent) => {
  try {
    const { title, type, ...props } = event;

    const globalAttributes = getGlobalsSnapshot();
    const globalAttributesResolver = getGlobalAttributesResolver();
    const resolvedGlobalAttributes = globalAttributesResolver?.() ?? {};

    const serialize = (obj?: Record<string, unknown>) =>
      serializeObject({
        obj,
        keySerializer: defaultKeySerializer,
        valueSerializer: defaultValueSerializer,
      });

    const eventType = type
      ? { ['Event Type']: attrNameToDisplayName(type) }
      : {};

    const attributes: NormalizedEventAttributes = onlyValidAttributes({
      ...eventType,
      ...serialize(resolvedGlobalAttributes),
      ...serialize(globalAttributes),
      ...serialize(props),
      ...serialize({ analyticsVersion }),
    });

    notifyEvent(title, attributes);
  } catch (e) {
    console.error(e);
    getGlobalErrorHandler()?.(e);
  }
};
